/**
 * EvalMetricsPanel Component
 * Metric definitions management panel for the Evaluation Center
 */

import { MetricDefinitionList } from '@/features/eval-scenarios';

export function EvalMetricsPanel() {
  return <MetricDefinitionList />;
}
